import React from "react";
import localStore from "src/utils/local-storage";
import { checkCanEditPublish } from "src/utils/checkPublishPermission";

const user = localStore.get("_user");

export default function ButtonTrash({ postItem = {}, actionTrashPost }) {
  let canEditPublishPost = true;

  // người không có chuyên mục xuất bản thì không được quyền edit bài đã xuất bản chuyên mục đó
  // không hiện nút 'bỏ rác' trong trường hợp này
  if (postItem.posttype && postItem.posttype.type_code === "ready") {
    canEditPublishPost = checkCanEditPublish(postItem);
  }

  const condition =
    user.can_publish &&
    !postItem.editing_status &&
    postItem.posttype.type_code !== "trash" &&
    canEditPublishPost;

  if (!condition) {
    return <></>;
  }

  return (
    <button className="btn btn-dark btn-sm mr-2" onClick={actionTrashPost}>
      <i className="fas fa-trash"></i> Bỏ rác
    </button>
  );
}
